// extracted by mini-css-extract-plugin
module.exports = {"root":"Faq_root__RzoBh","trigger":"Faq_trigger___Op8_","decimalList":"Faq_decimalList__n4zJc","warning":"Faq_warning__L9lgj"};